module.exports = __webpack_public_path__ + "img/blurmap-VARILUX-S-SERIES_full_white.98db2040.png";